import {
    Dropdown,
    Modal
} from "bootstrap";

const portalModal   = document.getElementById('portalHome');
const loginModal    = document.getElementById('loginHome');
const registerModal = document.getElementById('registerHome');

[portalModal, loginModal, registerModal].forEach((modal) => {
    modal.addEventListener('show.bs.modal', (event) => {
        if(event.currentTarget.querySelector('iframe')) {
            event.currentTarget.querySelector('iframe').src = event.currentTarget.dataset.homeUrl;
        }
    })
});

const params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

if(params.actie && params.nonce && params.actie === 'aanmelden') {
    loginModal.dataset.homeUrl = loginModal.dataset.homeUrl + '?actie=' + params.actie + '&nonce=' + params.nonce;

    const modal = Modal.getOrCreateInstance(loginModal);
    modal.show();

    window.history.pushState({}, document.title, '/');
}